import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-884955d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "StoryMenu fixed inset-0 z-1 text-white overflow-hidden pointer-events-auto" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Backdrop absolute inset-0 bg-true-black/60" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Background absolute top-0 inset-x-0 flex flex-col" }, null, -1));
const _hoisted_4 = { class: "Chapters container gap-y-32 lg:gap-y-0 h-full items-center content-center lg:content-evenly" };
const _hoisted_5 = ["disabled", "onClick"];
const _hoisted_6 = { class: "Chapter__Caption flex-1 grid *:row-start-1 *:col-start-1 mb-8 lg:mb-0 text-mobile-cap lg:text-desktop-body group-disabled:opacity-20" };
const _hoisted_7 = {
    key: 0,
    class: "opacity-0 transition-opacity group-hover:opacity-100"
};
const _hoisted_8 = { class: "Glass absolute z-1 flex justify-center items-center size-0" };
const _hoisted_9 = { class: "StoryMenu__UI absolute top-0 right-0 lg:top-24 lg:right-24 flex items-center h-56 lg:h-40 px-20 lg:px-0" };
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { onKeyDown } from "@vueuse/core";
import useGSAP from "@/composables/useGSAP";
import useStoryChapters from "@/composables/useStoryChapters";
import useMouseParallax from "@/composables/useMouseParallax";
import { useStoryState } from "@/services/Composition";
import Viewport from "@/store/modules/Viewport";
import { setFPS } from "@/utils/frameToTime";
import content from "@/config/content";
import AppService from "@/services/AppService";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoryMenu',
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const { t } = useI18n();
        const { currentChapter, isChapterAvailable, isChapterCompleted } = useStoryChapters();
        const { state, send } = useStoryState();
        const shards = ref([]);
        const images = ref([]);
        const { pause: pauseShardsParallax, resume: playShardsParallax } = useMouseParallax(shards);
        const { pause: pauseImagesParallax, resume: playImagesParallax } = useMouseParallax(images, { amplitude: 10, opposite: false });
        const gsap = useGSAP();
        const frames = setFPS(60);
        const chaptersCSS = [
            "lg:row-start-1 lg:col-start-2 lg:col-span-8 lg:flex-wrap lg:items-baseline lg:gap-y-8 lg:max-w-cols-7 mx-auto",
            "lg:row-start-2 lg:col-start-7 lg:col-span-6 lg:flex-wrap lg:items-baseline lg:gap-y-8 lg:max-w-cols-5 mx-auto lg:-mb-em",
            "lg:row-start-3 lg:col-start-2 lg:col-span-4 lg:flex-col lg:items-end lg:gap-y-8 lg:w-max mx-auto lg:mx-0",
            "lg:row-start-4 lg:col-start-7 lg:col-span-3 lg:flex-col-reverse lg:items-start lg:gap-y-8 lg:w-max mx-auto lg:mx-0",
        ];
        const canChangeChapter = computed(() => state.value.matches("story.scene.default"));
        const chapters = computed(() => content.chapters.map(({ titlekey, image }, i) => ({
            title: t(titlekey),
            image: Object.assign(Object.assign({}, image), { src: [`${image.src}.avif`, `${image.src}.webp`] }),
            status: currentChapter.value === i ? "active" : isChapterCompleted(i) ? "completed" : isChapterAvailable(i) ? "unlocked" : "locked",
            disabled: !isChapterAvailable(i) || !canChangeChapter.value,
            css: chaptersCSS[i]
        })));
        const titles = computed(() => chapters.value.map(({ title }) => title.split("\n")));
        const goto = (chapter) => {
            if (!isChapterAvailable(chapter))
                return;
            send({ type: "GO_TO", chapter, scene: 0 });
            close();
        };
        const close = () => {
            if (Viewport.isMobile)
                AppService.glapp.start();
            emit("close");
        };
        function onBeforeEnter(el) {
            const $ = gsap.utils.selector(el);
            gsap.set($(".Glass"), { y: 0, rotation: 0 });
            gsap.set($(".Chapter"), { y: 0 });
            gsap.set($(".Chapters"), { clearProps: "opacity,transform" });
            gsap.set($(".Chapter__Title, .Chapter__Status"), { clearProps: "opacity" });
            shards.value = $(".UIShard");
            images.value = shards.value.map((el) => el.querySelector("img"));
            playShardsParallax();
            playImagesParallax();
        }
        function onEnter(el, onComplete) {
            if (Viewport.isMobile)
                AppService.glapp.stop();
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                defaults: {
                    ease: "ease.out"
                }
            });
            tl
                .addLabel("items", frames(23))
                .fromTo($(".Backdrop"), {
                opacity: 0
            }, {
                opacity: 1,
                duration: frames(40)
            }, 0)
                .fromTo($(".StoryMenu__UI"), {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                duration: frames(30)
            }, frames(38));
            // offset chapters
            const items = $(".Chapter");
            let itemYFrom = Viewport.windowHeight;
            let shardYFrom = Viewport.windowHeight;
            items.forEach((item, i) => {
                const contents = gsap.utils.toArray(".Chapter__Title, .Chapter__Status", item);
                const glass = item.querySelector(".Glass");
                const shard = glass.querySelector(".UIShard");
                if (i === 0) {
                    itemYFrom -= item.getBoundingClientRect().top;
                    shardYFrom -= shard.getBoundingClientRect().top;
                }
                tl
                    .from(item, {
                    y: itemYFrom,
                    duration: frames(50),
                    onComplete: i === items.length - 1 ? onComplete : undefined
                }, `items+=${frames(i * 6)}`)
                    .from(contents, {
                    opacity: 0,
                    clearProps: "opacity",
                    duration: frames(50)
                }, "<")
                    .from(glass, {
                    y: shardYFrom,
                    duration: frames(60)
                }, "<")
                    .float(glass, {
                    duration: [frames(i % 2 === 0 ? 210 : 180), frames(i % 2 === 0 ? 180 : 210)]
                }, ">");
            });
        }
        function onLeave(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                onComplete,
                defaults: {
                    ease: "ease.out"
                }
            });
            tl
                .to($(".Backdrop"), {
                opacity: 0,
                duration: frames(40)
            }, 0)
                .to($(".Chapters"), {
                opacity: 0,
                yPercent: 100,
                duration: frames(30)
            }, "<")
                .to($(".StoryMenu__UI"), {
                autoAlpha: 0,
                duration: frames(30)
            }, "<");
        }
        function onAfterLeave(el) {
            const $ = gsap.utils.selector(el);
            gsap.killTweensOf($(".Glass"));
            pauseShardsParallax();
            pauseImagesParallax();
        }
        onKeyDown(["Escape"], close);
        return (_ctx, _cache) => {
            const _component_UIStoryStatus = _resolveComponent("UIStoryStatus");
            const _component_UIImage = _resolveComponent("UIImage");
            const _component_UIShard = _resolveComponent("UIShard");
            const _component_UIBtnClose = _resolveComponent("UIBtnClose");
            const _directive_cursor = _resolveDirective("cursor");
            const _directive_sound = _resolveDirective("sound");
            return (_openBlock(), _createBlock(_Transition, {
                onBeforeEnter: onBeforeEnter,
                onEnter: onEnter,
                onLeave: onLeave,
                onAfterLeave: onAfterLeave
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _hoisted_3,
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chapters.value, ({ image, status, disabled, css }, i) => {
                                return _withDirectives((_openBlock(), _createElementBlock("button", {
                                    key: i,
                                    type: "button",
                                    class: _normalizeClass(["Chapter group col-span-full relative flex flex-col lg:flex-row items-center lg:gap-x-2 text-mobile-title lg:text-desktop-h4 text-left disabled:pointer-events-none", css]),
                                    disabled: disabled,
                                    onClick: ($event) => (goto(i))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titles.value[i], (line, j) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                            key: j,
                                            class: _normalizeClass(["Chapter__Title relative flex flex-col items-center gap-8 lg:flex-row lg:items-baseline transition-colors duration-666 ease-out group-disabled:opacity-20 group-hover:text-accent", { 'text-accent': status === 'active' }])
                                        }, [
                                            _createTextVNode(_toDisplayString(line) + " ", 1),
                                            (j === titles.value[i].length - 1)
                                                ? (_openBlock(), _createBlock(_component_UIStoryStatus, {
                                                    key: 0,
                                                    class: "Chapter__Status lg:absolute lg:right-full lg:bottom-0 lg:mr-gutter",
                                                    status: status
                                                }, null, 8, ["status"]))
                                                : _createCommentVNode("", true)
                                        ], 2));
                                    }), 128)),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["Chapter__Index", { 'opacity-100 transition-opacity group-hover:opacity-0': status === 'active' }])
                                        }, _toDisplayString(_ctx.$t("global.chapter")), 3),
                                        (status === 'active')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("menu.restart")), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_UIShard, { variant: i }, {
                                            default: _withCtx(() => [
                                                (status !== 'locked')
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: _normalizeClass(["Chapter__Image size-full mix-blend-lighten transition-opacity duration-666 ease-out", { 'opacity-0 group-hover:opacity-100': status !== 'active' }])
                                                    }, [
                                                        _createVNode(_component_UIImage, _mergeProps(image, { class: "opacity-65" }), null, 16)
                                                    ], 2))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                        }, 1032, ["variant"])
                                    ])
                                ], 10, _hoisted_5)), [
                                    [
                                        _directive_cursor,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                    ],
                                    [
                                        _directive_sound,
                                        void 0,
                                        void 0,
                                        {
                                            hover: true,
                                            click: true
                                        }
                                    ]
                                ]);
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_UIBtnClose, { onClick: close })
                        ])
                    ])
                ]),
                _: 1
            }));
        };
    }
});
